/**
 * Full-viewport branded wait state for cold boot / auth gates.
 * Used when Layout chrome is not mounted yet — RouteFallback alone reads as
 * a blank cream screen on mobile Safari resume.
 */
import { useTranslation } from 'react-i18next';
import { BrandSeal } from './BrandSeal';

export function BootSplash() {
  const { t } = useTranslation();
  return (
    <div
      className="flex min-h-[100dvh] flex-col items-center justify-center gap-3 bg-papel px-6 pt-[env(safe-area-inset-top)] pb-[env(safe-area-inset-bottom)]"
      role="status"
      aria-live="polite"
      data-boot-splash
    >
      <BrandSeal className="h-[3.25rem] w-[3.25rem] motion-safe:animate-pulse" />
      <p className="font-serif text-[1.65rem] font-medium tracking-tight text-tinta">
        Suturia
      </p>
      <p className="text-[13px] text-tinta-3">{t('common.loading')}</p>
    </div>
  );
}
